/* (c) Copyright 2020 Pivotal Software, Inc. All Rights Reserved. */
"use strict";

exports.__esModule = true;
exports["default"] = void 0;

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var privates = new WeakMap();

var _default = function _default(ParentClass) {
  return /*#__PURE__*/function (_ParentClass) {
    _inheritsLoose(Mounted, _ParentClass);

    function Mounted() {
      return _ParentClass.apply(this, arguments) || this;
    }

    var _proto = Mounted.prototype;

    _proto.componentDidMount = function componentDidMount() {
      privates.set(this, {
        isMounted: true
      });
      if (_ParentClass.prototype.componentDidMount) _ParentClass.prototype.componentDidMount.call(this);
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      privates["delete"](this);
      if (_ParentClass.prototype.componentWillUnmount) _ParentClass.prototype.componentWillUnmount.call(this);
    };

    _proto.mounted = function mounted() {
      var _ref = privates.get(this) || {},
          isMounted = _ref.isMounted;

      return !!isMounted;
    };

    return Mounted;
  }(ParentClass);
};

exports["default"] = _default;